import { render, staticRenderFns } from "./topbar.vue?vue&type=template&id=72f827fa&scoped=true&"
import script from "./topbar.vue?vue&type=script&lang=js&"
export * from "./topbar.vue?vue&type=script&lang=js&"
import style0 from "./topbar.vue?vue&type=style&index=0&id=72f827fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f827fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72f827fa')) {
      api.createRecord('72f827fa', component.options)
    } else {
      api.reload('72f827fa', component.options)
    }
    module.hot.accept("./topbar.vue?vue&type=template&id=72f827fa&scoped=true&", function () {
      api.rerender('72f827fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/onboarding/client/selectTeam/topbar.vue"
export default component.exports